import { forwardRef, type PropsWithChildren } from "react";

type Props = {
  onClick?: VoidFunction;
};

const WidgetButton = forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(
  ({ onClick, children }, ref) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        type="button"
        className="ml-auto cursor-pointer rounded-full bg-white p-2 shadow outline-none transition-shadow hover:shadow-lg"
      >
        {children}
      </button>
    );
  },
);

WidgetButton.displayName = "WidgetButton";

export default WidgetButton;
